import React, { Component } from 'react';
import './CreateFAQ.css';

class CreateFAQ extends Component {
    render() {
        return (
            <div className="CreateFAQ">
                <p className="col-md-6 mt-2 p-0 fontsize4 font-weight-bold ">Create FAQ</p>
                <hr />
                <div className="form-group col-lg-7  my-4">
                    <label htmlFor="question" className="fontsize12 text-muted">Type your question</label>
                    <input type="text" className="form-control badge-pill" id="question" aria-describedby="question" placeholder="Type your question" name="questionEN" value={this.props.state.questionEN} onChange={this.props.handleChange} />
                </div>
                <div style={{ fontSize: 12, color: "red"}}>
                    {this.props.state.questionENError}
                </div>
                <div className="form-group col-lg-7">
                    <label htmlFor="answer" className="fontsize12 text-muted">Type your answer</label>
                    <textarea className="form-control" id="exampleFormControlTextarea1 badge-pill" rows="5" placeholder="Type your answer" name="answerEN" value={this.props.state.answerEN} onChange={this.props.handleChange}></textarea>
                </div>
                <div style={{ fontSize: 12, color: "red"}}>
                    {this.props.state.answerENError}
                </div>
                <div className="rtl text-right">
                    <div className="form-group col-lg-7 mx-auto my-4">
                        <label htmlFor="question1" className="fontsize12 text-muted ">اكتب السؤال</label>
                        <input type="text" className="form-control badge-pill" id="question1" aria-describedby="question" placeholder="اكتب السؤال" name="questionAR" value={this.props.state.questionAR} onChange={this.props.handleChange} />
                    </div>
                    <div style={{ fontSize: 12, color: "red" ,textAlign: "center"}}>
                        {this.props.state.questionARError}
                    </div>
                    <div className="form-group mx-auto col-lg-7">
                        <label htmlFor="answer1 " className="fontsize12 text-muted">اكتب اجابة السؤال</label>
                        <textarea className="form-control" id="answer1 badge-pill" rows="5" placeholder="اكتب اجابة السؤال" name="answerAR" value={this.props.state.answerAR} onChange={this.props.handleChange}></textarea>
                    </div>
                    <div style={{ fontSize: 12, color: "red" ,textAlign: "center" }}>
                        {this.props.state.answerARError}
                    </div>
                </div>

                <button onClick={this.props.newFAQ} className="text-white badge-pill p-2 pl-1 px-3 border shadow bluebg text-center m-4">create</button>

            </div>
        )
    }
}
export default CreateFAQ;